import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Create a context for the GraphQL data
const ConfigsContext = createContext();

export const useConfigs = () => {
  return useContext(ConfigsContext);
};

export const ConfigsProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://www.rennamobile.com/api/backend/graphql-data');
        console.log('GraphQL Data from Strapi:', response.data);
        setData(response.data.data);
      } catch (error) {
        console.error('Error fetching GraphQL data:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (!data) {
      fetchData(); // Fetch the data if it doesn't already exist
    }
  }, [data]); // Ensures the effect runs only when the data is null

  return (
    <ConfigsContext.Provider value={{ loading, error, data }}>
      {children}
    </ConfigsContext.Provider>
  );
};
